module.exports = __webpack_public_path__ + "media/images/regions/thumbnails/east_asia_and_pacific-92751ae5bd1cb5166eb3bde6c1001027.png";